import { bindable, autoinject } from 'aurelia-framework';
import { DOM } from 'aurelia-pal';
import he from 'he';
import { PayrazrService } from '../../services/payrazr';
import { Router } from 'aurelia-router';

@autoinject()
export class DisclosuresCustomElement {
	@bindable hideAgreed: boolean;
	content: any;

	constructor(private element: Element, private payrazrService: PayrazrService, private router: Router) {
		this.element = element;
        this.payrazrService = payrazrService;
        this.content = '';
	}

	attached() {
		this.payrazrService.getDisclosure()
			.then(result => {
				if (result === null || result === undefined) {
					this.content = '';
				}
				else {
					this.content = he.decode(result);
				}
			})
			.catch(error => {
				console.log(`error getting disclosures: ${JSON.stringify(error)}`);
			});
	}

	theyAgreed() {
		let eventData = { value: true };
		let evt = DOM.createCustomEvent('agreed', { bubbles: true, cancelable: true, detail: eventData });
		this.element.dispatchEvent(evt);
	}
}